import { parseApiError } from './http-error';

const BASE = `${(import.meta.env.VITE_API_URL ?? 'http://localhost:3000').replace(/\/$/, '')}/api/v1`;
const TOKEN_KEY = 'luvelle_access_token';

function authHeaders(): Record<string, string> {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function unwrap<T>(data: any): T {
  if (data && typeof data === 'object' && 'data' in data && 'success' in data) {
    return data.data as T;
  }
  return data as T;
}

async function request<T>(
  path: string,
  init: RequestInit & { method?: string } = {},
): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      ...authHeaders(),
      ...(init.headers ?? {}),
    },
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw parseApiError(res.status, json);
  return unwrap<T>(json);
}

export interface Profile {
  id: string;
  fullName: string;
  phone: string;
  email: string | null;
  isNafathVerified: boolean;
  nafathVerifiedAt: string | null;
  organizationId: string;
  createdAt: string;
}

export interface ProfileUpdate {
  fullName?: string;
  email?: string;
}

export type PropertyType = 'apartment' | 'villa' | 'duplex' | 'palace' | 'commercial';

export interface Address {
  id: string;
  label: string;
  type: PropertyType;
  city: string;
  district: string;
  street: string;
  building: string | null;
  postalCode: string | null;
  zone: string;
  lat: number | null;
  lng: number | null;
  isDefault: boolean;
  createdAt: string;
}

export interface AddressInput {
  label: string;
  type: PropertyType;
  city: string;
  district: string;
  street: string;
  building?: string;
  postalCode?: string;
  zone: string;
  lat?: number;
  lng?: number;
  isDefault?: boolean;
}

export const accountApi = {
  profile: () => request<Profile>('/mobile/luvelle/profile'),
  updateProfile: (dto: ProfileUpdate) =>
    request<Profile>('/mobile/luvelle/profile', {
      method: 'PATCH',
      body: JSON.stringify(dto),
    }),

  listAddresses: () => request<Address[]>('/mobile/luvelle/addresses'),
  createAddress: (dto: AddressInput) =>
    request<Address>('/mobile/luvelle/addresses', {
      method: 'POST',
      body: JSON.stringify(dto),
    }),
  updateAddress: (id: string, dto: Partial<AddressInput>) =>
    request<Address>(`/mobile/luvelle/addresses/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: JSON.stringify(dto),
    }),
  deleteAddress: (id: string) =>
    request<{ ok: true }>(`/mobile/luvelle/addresses/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    }),
};
